import React from 'react';
import { Card } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { Box } from '@mui/material';

const VideoTile = ({ data, onClick, className = "" }) => {
    const handleClick = () => {
        if (onClick) {
            onClick(data);
        }
    };

    return (
        <Box
            className={`video-tile ${className}`}
            sx={{
                width: { xs: 'calc(50vw - 16px)', sm: '280px', md: '300px' },
                minHeight: { xs: '160px', sm: '180px', md: '200px' },
                cursor: 'pointer',
                margin: 1
            }}
            onClick={handleClick}
        >
            <Card style={{ width: '100%', height: '100%' }}>
                <div 
                    style={{
                        backgroundColor: '#f0f0f0', 
                        height: window.innerWidth < 768 ? '100px' : '150px',
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        position: 'relative'
                    }}
                >
                    {data.thumbnail_url ? (
                        <img 
                            src={data.thumbnail_url} 
                            alt="Video thumbnail"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    ) : (
                        <Icon.CameraVideo size={window.innerWidth < 768 ? 30 : 50} className="text-secondary" />
                    )}
                    <Icon.PlayCircleFill 
                        size={window.innerWidth < 768 ? 30 : 40} 
                        className="position-absolute text-white"
                        style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
                    />
                </div>
                <Card.Body>
                    <h6 className="mb-2" style={{ fontSize: window.innerWidth < 768 ? '14px' : '16px' }}>
                        {data.title || '動画タイトル'}
                    </h6>
                    <div className="d-flex justify-content-between align-items-center">
                        <small className="text-muted" style={{ fontSize: window.innerWidth < 768 ? '10px' : '12px' }}>
                            作成者: {data.user_name || 'Unknown'}
                        </small>
                        <small className="text-muted" style={{ fontSize: window.innerWidth < 768 ? '10px' : '12px' }}>
                            {data.duration ? `${Math.floor(data.duration / 60)}:${(data.duration % 60).toString().padStart(2, '0')}` : ''}
                        </small>
                    </div>
                </Card.Body>
            </Card>
        </Box>
    );
};

export default VideoTile;
